export default __webpack_public_path__ + "static/media/solace_connect.08a88fdd.png";